module.exports = __webpack_public_path__ + "static/media/8.717d210a.jpg";